import React from 'react'
import { Heading, Text} from 'base-ui'
import { PageWrapper } from './PageWrapper'
import { Fill } from './Fill'

const Fills = () => {
  return (
    <PageWrapper title="Fills">
        <Text size="md"> Gallery of colors used across Paro products. Please view the most current <a target="_blank" className="font-semibold hover:underline" href="https://github.com/paroadmin/base-ui/blob/main/web/tailwind.config.js">tailwind.config.js</a> file to get the correct color palette for your project. </Text>
        <Heading size="h2">Brand Color Fills</Heading>

        <Heading size="h3">Primary on Light (Primary)</Heading>
        <div className='flex space-x-2'>
            <Fill name="bg-primary-lighter" hex="A7CDCE" />
            <Fill name="bg-primary-light" hex="66A8A9" />
            <Fill name="bg-primary" hex="248384" />
            <Fill name="bg-primary-dark" hex="195C5C" reverseColor={true} />
            <Fill name="bg-primary-darker" hex="0E3435" reverseColor={true} />
        </div>

        <Heading size="h3">Primary on Dark</Heading>
        <div className='flex space-x-2 bg-gray-900 border-8 border-gray-900'>
            <Fill name="bg-primary_on_dark-lighter" hex="FDD7A5" />
            <Fill name="bg-primary_on_dark-light" hex="FCB861" />
            <Fill name="bg-primary_on_dark" hex="FB9A1D" />
            <Fill name="bg-primary_on_dark-dark" hex="B06C14" reverseColor={true} />
            <Fill name="bg-primary_on_dark-darker" hex="643E0C" reverseColor={true}/>
        </div>

        <Heading size="h3">Solid Backgrounds</Heading>
        <div className='flex space-x-2'>
            <Fill name="bg-blue" hex="060821"  reverseColor={true}/>
            <Fill name="bg-purple" hex="282B52" reverseColor={true}/>
            <Fill name="bg-gray-50" hex="F8FAFC" />
            <Fill name="bg-white" hex="FFFFFF" />
            <Fill name="bg-ice" hex="D9EFEF" />
            <Fill name="bg-aqua" hex="A1E5E6" />
        </div>

        <Heading size="h3">Gradient Backgrounds</Heading>
        <div className='flex space-x-2'>
            <Fill name="bg-gradient-to-r from-ice"/>
            <Fill name="bg-gradient-to-r from-primary to-primary-lighter" />
            <Fill name="bg-gradient-to-r from-purple-light" />
            <Fill name="bg-gradient-to-r from-primary_on_dark-light to-primary_on_dark"  />
            <Fill name="bg-gradient-to-r from-purple to-purple-dark" reverseColor={true} />
        </div>



        <Heading size="h2" className='mt-8'>Status Color Fills</Heading>

        <Heading size="h3">Success</Heading>
        <div className='flex space-x-2'>
            <Fill name="bg-success-lighter" hex="C9FFF3" />
            <Fill name="bg-success-light" hex="00FFC6" />
            <Fill name="bg-success" hex="06F1BC" />
            <Fill name="bg-success-dark" hex="04E4B1" />
            <Fill name="bg-success-darker" hex="009D79" />
        </div>

        <Heading size="h3">Info</Heading>
        <div className='flex space-x-2'>
            <Fill name="bg-info-lighter" hex="C9EAFF" />
            <Fill name="bg-info-light" hex="56C4FF" />
            <Fill name="bg-info" hex="4CBAFF" />
            <Fill name="bg-info-dark" hex="00AEF1" />
            <Fill name="bg-info-darker" hex="2E7099" />
        </div>

        <Heading size="h3">Warning</Heading>
        <div className='flex space-x-2'>
            <Fill name="bg-warning-lighter" hex="FFF4D8" />
            <Fill name="bg-warning-light" hex="FFE38F" />
            <Fill name="bg-warning" hex="FFDB7C" />
            <Fill name="bg-warning-dark" hex="F0CB5B" />
            <Fill name="bg-warning-darker" hex="99834A" />
        </div>

        <Heading size="h3">Danger</Heading>
        <div className='flex space-x-2'>
            <Fill name="bg-danger-lighter" hex="FFDBDB" />
            <Fill name="bg-danger-light" hex="FF9191" />
            <Fill name="bg-danger" hex="FF8787" />
            <Fill name="bg-danger-dark" hex="F17175" />
            <Fill name="bg-danger-darker" hex="995151" />
        </div>

        <Heading size="h2" className='mt-8'>Theme</Heading>
        
        <Text size="md" className='mb-4'> Uses Tailwind's default classes configured to use: gray: colors.blueGray. View the current tailwind config file for more information.</Text>
        <div className='flex space-x-2'>
            <Fill name="bg-gray-50" hex="F8FAFC" />
            <Fill name="bg-gray-100" hex="F1F5F9" />
            <Fill name="bg-gray-200" hex="E2E8F0" />
            <Fill name="bg-gray-300" hex="CBD5E1" />
            <Fill name="bg-gray-400" hex="94A3B8" />
        </div>

        <div className='flex space-x-2 mt-2'>
            <Fill name="bg-gray-500" hex="64748B" reverseColor={true}/>
            <Fill name="bg-gray-600" hex="475569" reverseColor={true}/>
            <Fill name="bg-gray-700" hex="334155" reverseColor={true}/>
            <Fill name="bg-gray-800" hex="1E293B" reverseColor={true}/>
            <Fill name="bg-gray-900" hex="0F172A" reverseColor={true}/>
        </div>

    </PageWrapper>
  )
}

export default Fills
